import styled from '@emotion/styled';

import { FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';
import matchingInviteMobile from 'assets/images/pages/themeListing/matching_invite_mobile@2x.jpg';
import { MagicTag } from 'cards/components/common/Tags/MagicTag/MagicTag';

export const ThemePreviewTile = styled.div`
  height: 287px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  cursor: pointer;
  &:hover,
  &:focus-within {
    .tileActionsOverlay {
      display: flex;
    }
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);
  }
`;

const ThemeTitle = styled.h4`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALL)}
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: 8px 0;
  display: flex;
  align-items: center;
  [class^='tagV2__'] {
    margin: 0 0 0 8px;
  }
`;

const Container = styled.div<{ hideHoverActions?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  width: 50%;
  color: ${COLORS.BLACK_100};

  ${ThemePreviewTile}:hover + ${ThemeTitle} {
      color: ${COLORS.BLACK_075};
      text-decoration: underline;
  }

  ${({ hideHoverActions }) =>
    !hideHoverActions &&
    `
  ${MEDIA_QUERY.MOBILE} {
    padding: 0;
    &:nth-of-type(2n + 1) {
      padding: 0 10px 0 0;
    }
    &:nth-of-type(2n) {
      padding: 0 0 0 10px;
    }
  }
  // Tablet and Small Desktop
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 33%;
    padding: 0 10px;
    &:nth-of-type(3n + 1) {
      padding: 0 10px 0 0;
    }
    &:nth-of-type(3n) {
      padding: 0 0 0 10px;
    }
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    width: 25%;
    padding: 0 10px;
    &:nth-of-type(4n + 1) {
      padding: 0 10px 0 0;
    }
    &:nth-of-type(4n) {
      padding: 0 0 0 10px;
    }
  }
  `}


  [class^='tagV2__'] {
    margin-top: 8px;
    width: fit-content;
    height: 100%;
    flex-basis: 0;
  }
`;

export const MarketingModuleContainer = styled(Container)`
  a {
    outline-offset: 3px;
  }
  ${ThemePreviewTile} {
    background-image: url(${matchingInviteMobile});
    background-position: top;
    background-size: cover;
  }
`;

export const StyledMagicTag = styled(MagicTag)`
  margin: 0 0 ${SPACING.S16} 0;
  max-width: 110px;
  width: 110px;
`;
